import { render } from "./SurveyTemplateScoreRatingsEditor.vue?vue&type=template&id=6e79ca74"
import script from "./SurveyTemplateScoreRatingsEditor.vue?vue&type=script&lang=js"
export * from "./SurveyTemplateScoreRatingsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__